module.exports = __webpack_public_path__ + "media/Barai-Ba-K.ad4316cc.mp3";